import { useCallback } from 'react';
import { sendMessageToParentFrame } from '@/utils/sendMessageToParentFrame';

export const useOpenSidebar = () => {
  const open = useCallback((isOpen: boolean) => {
    sendMessageToParentFrame({
      sidebar_open: isOpen,
    });
  }, []);

  return { open };
};
